import React from "react";
import { createPortal } from "react-dom";

const ToastPortal = ({ children }: { children: React.ReactNode }) => {
  return createPortal(children, document.getElementById("toast-root")!);
};

export default ToastPortal;
